module.exports = __webpack_public_path__ + "img/reviews.2cce0c26.png";